// Dimension a pivot axis groups linked cards by.
export type PivotDimensionId = "art" | "team" | "iteration" | "status" | "objective";

export const DEFAULT_PIVOT_ROW_DIM: PivotDimensionId = "team";
export const DEFAULT_PIVOT_COL_DIM: PivotDimensionId = "iteration";
